import React, { useId } from 'react';
import { CloudinaryPicture, WIDTH_LADDERS } from 'components/rich';

import NEWSLETTER_ISSUES, { issueUrl } from '../../lib/newsletterIssues';
import PdpIcon from '../product/pdpIcon';
import NewsletterForm, { UNSUBSCRIBE_NOTE } from './newsletterForm';
import useNewsletterSignup from './useNewsletterSignup';

// Press Sheet signup section for any page, the "Newsletter" section of "Print Sets — Redesign"
// in design/website.pen, plus "Newsletter — Subscribed state" and "— Signup error states".
// The roll card shows the latest issue. Styles: styles/_newsletter.scss (nlt- prefix).
const NewsletterTile = () => {
  const headingId = useId();
  const signup = useNewsletterSignup();
  const latest = NEWSLETTER_ISSUES[0];
  const [monthName, year] = latest.month.split(' ');
  const subscribed = Boolean(signup.subscribedEmail);

  return (
    <section className="nlt" aria-labelledby={headingId}>
      <div className="nlt-inner">
        <div className="nlt-copy">
          <div className="nlt-heading">
            <p className="nlt-eyebrow">
              <span className="nlt-eyebrow-label">Press Sheet</span>
              <span className="nlt-eyebrow-rule" aria-hidden="true" />
              <span>Monthly newsletter</span>
            </p>
            <h2 id={headingId} className="nlt-h2">
              {subscribed ? (
                <>
                  Thank you for <br className="nlt-break" />
                  subscribing.
                </>
              ) : (
                <>
                  Photos worth printing, <br className="nlt-break" />
                  once a month.
                </>
              )}
            </h2>
            <p className="nlt-sub">
              {subscribed
                ? 'You’re on the list for Press Sheet. The next roll will land in your inbox, with print ideas, photo tips and the occasional special offer.'
                : 'Each month we send Press Sheet, a short roll of print ideas, photo tips and what’s new at Parabo. When we run a special offer, subscribers hear about it first.'}
            </p>
          </div>

          {subscribed ? (
            <div className="nlt-form-group">
              <p className="nlt-subscribed" role="status">
                <span className="nlt-subscribed-badge">
                  <PdpIcon name="check" size={16} />
                </span>
                <span>Subscribed as {signup.subscribedEmail}</span>
              </p>
              <p className="nlt-note">{UNSUBSCRIBE_NOTE}</p>
            </div>
          ) : (
            <NewsletterForm signup={signup} tone="dark" />
          )}
        </div>

        <div className="nlt-roll">
          <a className="nlt-sheet" href={issueUrl(latest)} tabIndex={-1} aria-hidden="true">
            <span className="nlt-masthead">
              <span className="nlt-masthead-title">Press Sheet</span>
              <span className="nlt-sheet-label">
                Roll {latest.roll} · {monthName.slice(0, 3)} {year}
              </span>
            </span>
            <span className="nlt-sheet-photo">
              <CloudinaryPicture
                imageKey={latest.image.imageKey}
                prefix={latest.image.prefix}
                widths={WIDTH_LADDERS.categories}
                sizes="(min-width: 992px) 352px, calc(100vw - 80px)"
                alt=""
                loading="lazy"
              />
            </span>
            <span className="nlt-story">
              <span className="nlt-sheet-label">This month</span>
              <span className="nlt-story-title">{latest.title}</span>
            </span>
            <span className="nlt-film-edge">
              <span>Parabo 400</span>
              <span>Parabo 400</span>
              <span>Parabo 400</span>
            </span>
          </a>
          <div className="nlt-links">
            <a className="nlt-read" href={issueUrl(latest)}>
              Read Roll {latest.roll}
              <PdpIcon name="arrowRight" size={16} />
            </a>
            <a className="nlt-all" href="/newsletter">
              See all rolls
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterTile;
